/* shah */
import React from 'react'

const PositionsLeftRight = () => {
    return (
        <svg id='ICON-SVG-PositionsLeftRight' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M16.05 12.05L21 17l-4.95 4.95l-1.414-1.415L17.172 18H4v-2h13.172l-2.536-2.535zm-8.1-10l1.414 1.414l-2.536 2.535H20v2H6.828l2.536 2.536L7.95 11.95L3 7z" /></svg>
    )
}

export default PositionsLeftRight